import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="hbe-container py-24 text-center max-w-lg mx-auto" data-testid="notfound-page">
      <div className="hbe-eyebrow">404</div>
      <h1 className="mt-3 font-serif text-4xl">This page has drifted.</h1>
      <p className="mt-4 text-hbe-ink/70">
        The link you followed isn't quite where we docked it.
      </p>
      <Link to="/" className="hbe-btn-primary mt-8 inline-flex" data-testid="notfound-home">
        Back to shore
      </Link>
    </div>
  );
}
